import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ObyNominees from "./ObyNominees";
import CommunityNominees from "./CommunityNominees";
import DisabilityNominees from "./DisabilityNominees";
import SolutionNominees from "./SolutionNominees";
import CivicNominees from "./CivicNominees";
import HealthNominees from "./HealthNominees";
import ClimateNominees from "./ClimateNominees";

const NomineePage = () => {
  return (
    <Grid container>
      <Grid item xs={12} md={12} marginTop={{ xs: "5%", sm: "1%" }}>
        <Box paddingRight={{ xs: "0%", sm: "3%" }}>
          <Typography
            variant={"body1"}
            fontWeight={500}
            textAlign={"left"}
            padding={{ xs: "5% 0% 1% 0%", sm: "1% 0%" }}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            It is with great pleasure that we announce the 2023 Shortlisted
            Nominees of the maiden edition of Active Citizens Awards
          </Typography>
        </Box>
      </Grid>
      <ObyNominees />
      <CommunityNominees />
      <DisabilityNominees />
      <SolutionNominees />
      <CivicNominees />
      <HealthNominees />
      <ClimateNominees />
    </Grid>
  );
};

export default NomineePage;
